function getPageTitle(locale, pageName = '') {
	const siteTitle = locale === 'ja' ? 'Garden Eight - ガーデンエイト' : 'Garden Eight';

	return pageName === '' ? siteTitle : pageName + ' | ' + siteTitle;
}

export { getPageTitle };
